import { useTranslation } from 'react-i18next'

import { USER_STATUS_TEXT } from '../../../constants/user'
import { EntityArchivedIcon } from '../../Entity'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../Icon'
import { Status } from '../../Status'

import * as styles from './ListItemIcons.module.css'

import SelectedIcon from '../../../icons/done.svg'

function ListItemIcons({ children, isArchived, isSelected, userStatus }) {
  const { t } = useTranslation()

  return (
    <div className={styles.icons}>
      {isArchived ? (
        <EntityArchivedIcon tooltip='Select.ArchivedItemkey' />
      ) : null}
      {isSelected ? (
        <IconNG
          Icon={SelectedIcon}
          color={ICON_COLOR.ButtonBg}
          size={ICON_HEIGHT_16}
        />
      ) : null}
      {children}
      {Number.isFinite(userStatus) ? (
        <Status
          className={styles.chip}
          text={t(USER_STATUS_TEXT[userStatus].text)}
          textColor={USER_STATUS_TEXT[userStatus].color}
        />
      ) : null}
    </div>
  )
}

export default ListItemIcons
